export const APP_MUTATIONS = {
  // settings
  TOGGLE_PRIMARY_COLOR: 'TOGGLE_PRIMARY_COLOR',
  TOGGLE_NAV_THEME: 'TOGGLE_NAV_THEME',
  TOGGLE_LAYOUT: 'TOGGLE_LAYOUT',
  TOGGLE_CONTENT_WIDTH: 'TOGGLE_CONTENT_WIDTH',
  TOGGLE_FIXED_HEADER: 'TOGGLE_FIXED_HEADER',
  TOGGLE_FIXED_SIDERBAR: 'TOGGLE_FIXED_SIDERBAR',
  TOGGLE_COLOR_WEAK: 'TOGGLE_COLOR_WEAK',
  TOGGLE_MULTI_TAB: 'TOGGLE_MULTI_TAB',

  // 页面状态
  TOGGLE_SIDE_BAR_COLLAPSED: 'TOGGLE_SIDE_BAR_COLLAPSED',
  TOGGLE_CONTENT_FULL_SCREEN: 'TOGGLE_CONTENT_FULL_SCREEN',
  TOGGLE_DEVICE: 'TOGGLE_DEVICE',
  TOGGLE_SET_KEEPALIVE:'TOGGLE_SET_KEEPALIVE'
}

export const DICT = {
  SET_DICT_CACHE: 'set_dict_cache',
  SET_DICT_REQUEST_FLAG: 'del_dict_cache',
  DEL_DICT_REQUEST_FLAG: 'reset_dict_request_cache_item',
  DEL_DICT_CACHE: 'delete_invalid_dict'
}

export const LOV = {
  SET_CACHE: 'set_lov_cache',
  DEL_CACHE: 'del_lov_cache',
  SET_REQUEST: 'set_lov_request',
  DEL_REQUEST: 'del_lov_request'
}

